import { apiSlice } from "../../app/api/apiSlice"

export const freeTrialApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        requestFreeTrial: builder.mutation({
            query: request => ({
                url: '/free-trial/request',
                method: 'POST',
                body: {
                    ...request
                }
            })
        })
    })
})

export const {
    useRequestFreeTrialMutation
} = freeTrialApiSlice